import { gql } from '@apollo/client';

/**
 * GraphQL mutation to create a standard label
 */
export const CREATE_STANDARD_LABEL = gql`
  mutation CreateStandardLabel($input: CreateStandardLabelInput!) {
    createStandardLabel(input: $input) {
      label {
        id
        labelName
        labelShortName
        policy
        contentType
        labelStatus
        labelNumMap
        scope {
          global
          communities
          communityGroups
        }
        createdBy
        createdAt
        lastModifiedBy
        lastModifiedAt
      }
    }
  }
`;
